export const APPROVED_STATES = ["DONE", "PARTIAL_APPROVED"];
